import React from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { ARTWORK } from "../../types";
import FontSelector from "../Font/FontSelector";
import ColorField from "./Utilities/ColorField";
import FontSize from "./Utilities/FontSize";
import LayerAdvance from "./Utilities/LayerAdvance";
import LayerPosition from "./Utilities/LayerPosition";
// import PatternSelector from "./Utilities/patternSelector";
import TextAlign from "./Utilities/TextAlign";
import TextSpacing from "./Utilities/TextSpacing";
import TextStroke from "./Utilities/TextStroke";
import TextTransform from "./Utilities/TextTransform";
const Container = styled.div`
  display: flex;
  gap: 10px;
`;

const TextToolbar = ({ layer }) => {
  const dispatch = useDispatch();
  const handleFontChange = (fontFamily) => {
    onChange({ ...layer, fontFamily });
  };
  const onChange = (update) => {
    dispatch({
      type: ARTWORK.SET_LAYER,
      payload: { ...layer, ...update },
    });
  };
  // const handlePatternChange = (pattern) => {
  //   dispatch({
  //     type: ARTWORK.SET_LAYER,
  //     payload: { ...layer, _pattern: pattern },
  //   });
  // };
  return (
    <Container>
      <FontSelector fontFamily={layer.fontFamily} onSelect={handleFontChange} />
      <FontSize layer={layer} />
      <TextAlign layer={layer} />
      <TextSpacing layer={layer} />
      <ColorField
        value={layer.fill}
        onChange={(color) => onChange({ fill: color })}
      />
        <TextTransform
            layer={layer}
            onChange={(value) => {
                onChange(value);
            }}
        />
      {/*<PatternSelector layer={layer} onChange={handlePatternChange} />*/}
      <LayerPosition layer={layer} />
      <LayerAdvance layer={layer} />
      <TextStroke
        layer={layer}
        onChange={(value) => {
          onChange(value);
        }}
      />
    </Container>
  );
};

export default TextToolbar;
